export default __webpack_public_path__ + "static/ab-banking-610c69cf83d08c50fc1abad21705923a.jpg";